import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import IntroductionToEconomics from "./pages/economics/IntroductionToEconomics";
import DemandAndSupply from "./pages/economics/DemandAndSupply";
import Elasticity from "./pages/economics/Elasticity";
import Utility from "./pages/economics/Utility";
import CostStructure from "./pages/economics/CostStructure";
import MarketsFirms from "./pages/economics/MarketsFirms";
import LaborMarket from "./pages/economics/LaborMarket";
import GovernmentIntervention from "./pages/economics/GovernmentIntervention";
import GDP from "./pages/economics/GDP";
import MoneyMonetaryInstitutions from "./pages/economics/MoneyMonetaryInstitutions";
import CredibleInflationTargeting from "./pages/economics/CredibleInflationTargeting";
import AbsoluteValuationModels from "./pages/corporate_finance/AbsoluteValuationModels";
import WACC from "./pages/corporate_finance/WACC";
import CAPM from "./pages/corporate_finance/CAPM";
import IRR_MIRR from "./pages/corporate_finance/IRR_MIRR";
import GaussianCopulaFunction from "./pages/corporate_finance/GaussianCopulaFunction";
import Math from "./pages/Math";
import BusinessAssetShare from "./pages/commercial_law/BusinessAssetShare";
import DueDiligence from "./pages/commercial_law/DueDiligence";
import NonDisclossureAgreements from "./pages/commercial_law/NonDisclosureAgreements";
import WhiteWash from "./pages/commercial_law/WhiteWash";
import MACClauses from "./pages/commercial_law/MACClauses";

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/introduction-to-economics" element={<IntroductionToEconomics />} />
          <Route path="/demand-and-supply" element={<DemandAndSupply />} />
          <Route path="/elasticity" element={<Elasticity />} />
          <Route path="/utility" element={<Utility />} />
          <Route path="/cost-structure" element={<CostStructure />} />
          <Route path="/markets-firms" element={<MarketsFirms />} />
          <Route path="/labor-market" element={<LaborMarket />} />
          <Route path="/government-intervention" element={<GovernmentIntervention />} />
          <Route path="/gdp" element={<GDP />} />
          <Route path="/money-and-monetary-institutions" element={<MoneyMonetaryInstitutions />} />
          <Route path="/credible-inflation-targeting" element={<CredibleInflationTargeting />} />
          <Route path="/absolute-vauluation-models" element={<AbsoluteValuationModels />} />
          <Route path="/gaussian-copular-function" element={<GaussianCopulaFunction />} />
          <Route path="/wacc" element={<WACC />} />
          <Route path="/capm" element={<CAPM />} />
          <Route path="/irr_mirr" element={<IRR_MIRR />} />
          <Route path="/math" element={<Math />} />
          <Route path="/comm_1" element={<NonDisclossureAgreements />} />
          <Route path="/comm_2" element={<DueDiligence />} />
          <Route path="/comm_3" element={<BusinessAssetShare />} />
          <Route path="/comm_4" element={<WhiteWash />} />
          <Route path="/comm_5" element={<MACClauses />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
